import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import PluginClearFilter from './PluginClearFilter'

export default function PluginsFilterPrice ({ onPriceChange, price, plugins }) {
  const { t } = useTranslation(['plugins'])
  const [from, setFrom] = useState(0)
  const [to, setTo] = useState(0)
  const [
    currentPriceRange,
    setCurrentPriceRange
  ] = useState({ min: 0, max: 0 })
  const [
    defaultPriceRange,
    setDefaultPriceRange
  ] = useState({ min: 0, max: 0 })

  const resetCurrentPriceRange = () => {
    setFrom(defaultPriceRange.min / 100)
    setTo(defaultPriceRange.max / 100)
    setCurrentPriceRange(defaultPriceRange)

    onPriceChange([defaultPriceRange.min, defaultPriceRange.max])
  }

  function handleChange (value) {
    setFrom(value[0])
    setTo(value[1])
  }

  function handleRangeChange (value) {
    onPriceChange(value.map(v => v * 100))
  }

  useEffect(() => {
    if (!plugins.meta?.facets?.price) return

    const { min, max } = plugins.meta.facets.price

    // We can do this initially, because price is set in the index before.
    setFrom(min / 100)
    setTo(max / 100)
    setCurrentPriceRange({ min, max })

    if (defaultPriceRange.min === 0 && defaultPriceRange.max === 0) {
      setDefaultPriceRange({ min, max })
    }
  }, [plugins])

  return (
    <div>
      <button
        className="text-dark col-auto filter-bar__heading w-100 btn d-flex align-items-center justify-content-between fw-bold px-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapsePrice"
        aria-expanded="false"
        aria-controls="collapsePrice"
      >
        <strong className="text-dark mb-2 d-block">{t('browse_all.filter.price')}</strong>
        <svg
          viewBox="0 0 10 10"
          xmlns="http://www.w3.org/2000/svg"
          height="14"
          width="14"
        >
          <path
            d="M.5,2.75,4.646,7.1a.5.5,0,0,0,.708,0L9.5,2.75"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </button>
      <div
        className="collapse"
        id="collapsePrice"
      >
        <div className="position-relative">
          <Slider
            range
            allowCross={false}
            value={[from, to]}
            min={currentPriceRange.min / 100}
            max={currentPriceRange.max / 100}
            onChange={handleChange}
            onAfterChange={handleRangeChange}
          />
          <div className="d-flex justify-content-between">
            <span>{from} €</span>
            <span>{to} €</span>
          </div>
        </div>
        <PluginClearFilter callback={() => resetCurrentPriceRange()} />
      </div>
    </div>
  )
}
